<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
    <h4 class="modal-title" >{{TR "Als Bild exportieren"}}</h4>
</div>
<div class="modal-body">
    <div class="js-selections container">
        <div class="row">
            <div class="col-sm-12">
                <label class="control-label">{{TR "Beschriftung"}}</label>
            </div>
            <div class="col-sm-12">
                <input type="text" class="form-control js-custom-label" value="{{caption}}"></input>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button type="button" class="btn btn-primary" id="js-chart-export-submit">{{TR "Exportieren"}}</button>
</div>
